import { render } from "./SentEmails.vue?vue&type=template&id=1ec2c7cb&scoped=true"
import script from "./SentEmails.vue?vue&type=script&lang=js"
export * from "./SentEmails.vue?vue&type=script&lang=js"

import "./SentEmails.vue?vue&type=style&index=0&id=1ec2c7cb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec2c7cb"]])

export default __exports__